import Axios from "axios";

export default {
    getConfiguratorURL: function (packUid) {
        var data = new FormData();
        data.set("packUid", packUid);
        return Axios.post(URLSource.ajaxGetConfiguratorLink, data);
    },
    ajaxRemoveItemPack: function (packUid) {
        var data = new FormData();
        data.set("packUid", packUid);
        return Axios.post(URLSource.ajaxRemoveItemPack, data);
    },
    changeItemQuantity: function (itemId, quantity, configuratorUid) {
        var data = new FormData();
        data.set("itemId", itemId);
        data.set("quantity", quantity);
        data.set("configuratorUid", configuratorUid);
        return Axios.post(URLSource.ajaxChangeItemQuantity, data);
    },
    removeItem : function(itemId) {
        var data = new FormData();
        data.set("itemId", itemId);
        return Axios.post(URLSource.ajaxRemoveItem, data);
    },
    changePackQuantity: function (packUid, quantity) {
        var data = new FormData();
        data.set("packUid", packUid);
        data.set("quantity", quantity);
        return Axios.post(URLSource.ajaxChangePackQuantity, data);
    },
    ajaxSaveBed: function(bedData) {
        return Axios.post(URLSource.ajaxSaveBed, bedData);
    },
    setApplyCreditsBasket: function(value) {
        var data = new FormData();
        data.set("value", value);
        return Axios.post(URLSource.ajaxSetApplyBasket, data);
    },
    /**
     *
     * @param code
     * @returns {Promise<AxiosResponse<T>>}
     */
    validateVoucher: function(code) {
        var data = new FormData();
        data.set("code", code);
        return Axios.post(URLSource.ajaxValidateVoucher, data);
    },
    /**
     *
     * @param code
     * @returns {Promise<AxiosResponse<T>>}
     */
    removeVoucher: function(code) {
        var data = new FormData();
        data.set("code", code);
        return Axios.post(URLSource.ajaxRemoveVoucher, data);
    }

};
